"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.overrides = void 0;
/* ⚠️⚠️⚠️ DANGER ZONE ⚠️⚠️⚠️ DANGER ZONE ⚠️⚠️⚠️ DANGER ZONE ⚠️⚠️⚠️
 * Changing shared code can have unintended consequences for all brands.
 * Please double check with the team before making changes here.
 * If brand specific changes are needed, they should be made in the brand's theme file.
 */
var material_1 = require("@mui/material");
var resolveTypographyVariantStyles_1 = require("../../utils/resolveTypographyVariantStyles");
exports.overrides = {
    MuiInputBase: {
        styleOverrides: {
            root: (_a = {},
                _a["& .".concat(material_1.inputBaseClasses.input)] = {
                    boxSizing: 'content-box !important',
                },
                _a),
        },
    },
    MuiTabs: {
        styleOverrides: {
            root: function (_a) {
                var _b;
                var theme = _a.theme;
                return (_b = {},
                    _b["& .".concat(material_1.tabsClasses.indicator)] = {
                        backgroundColor: "var(--text-interactive, ".concat(theme.palette.text.interactive, ")"),
                    },
                    _b);
            },
        },
    },
    MuiTab: {
        styleOverrides: {
            root: function (_a) {
                var _b;
                var theme = _a.theme;
                return (__assign(__assign({}, (0, resolveTypographyVariantStyles_1.resolveTypographyVariantStyles)(theme, 'tabLabelInactive')), (_b = { color: "var(--text-secondary, ".concat(theme.palette.text.secondary, ")"), fontWeight: 350, textTransform: 'none', minHeight: '3rem', '&:hover': {
                            backgroundColor: "var(--background-neutral, ".concat(theme.palette.backgrounds.neutral, ")"),
                        }, '&:active': {
                            backgroundColor: "var(--background-neutral, ".concat(theme.palette.backgrounds.neutral, ")"),
                            color: "var(--text-interactive, ".concat(theme.palette.text.interactive, ")"),
                        } }, _b["&.".concat(material_1.tabClasses.selected)] = __assign({}, (0, resolveTypographyVariantStyles_1.resolveTypographyVariantStyles)(theme, 'tabLabelActive')), _b["& .".concat(material_1.touchRippleClasses.root)] = {
                    display: 'none',
                }, _b)));
            },
        },
    },
};
